import GetGifById from "../../../../src/mdx/api/endpoints/get-gif-by-id.mdx";
import * as React from 'react';
export default {
  GetGifById,
  React
};